const bg = {
    actionAlready: "Имате ли вече профил? Влезте в профила си",
    actionExit: "Излизане от системата",
    actionLogin: "ВЛЕЗТЕ В ПРОФИЛА СИ",
    actionRegister: "РЕГИСТРИРАЙТЕ СЕ",
    actionSave: "ЗАПАЗИ",
    actionStart: "СТАРТ",
    actionContinue: "ПРОДЪЛЖЕТЕ",
    actionReset: "ОЦЕНКА НА НУЛИРАНЕТО",
    actionDoDiagnost: "ПОКАЖИ ДИАГНОСТИКА",
    actionYes: "ДА",
    actionNo: "НЕ",
    actionNext: "СЛЕДВАЩО",
    actionBusinessCase: "ПОКАЖЕТЕ ИКОНОМИЧЕСКА ОБОСНОВКА",
    actionBusinessCases: "ПОКАЖЕТЕ ИКОНОМИЧЕСКИ ОБОСНОВКИ",
    actionOpenUrl: "ОТВОРИ URL АДРЕС",
    actionFilter: "ФИЛТЪР",
    
    /** HOME */
    msgHomeTitleOne: "Оценка и увеличаване на положителното въздействие на Вашата мебелна компания",
    msgHomeSubTitle: "Онлайн инструментът FurnCSR оценява текущия Ви напредък в областта на КСО въз основа на икономическите и организационните, обществените и екологичните ефекти",
    
    msgHomeSection2: "Изискванията за КСО се разрастват.</br>Подготвени ли сте?",
    msgHomeSection2Text: "<ul><li>Отговорете на въпросите за ежедневните си бизнес дейности в съответствие с основните критерии на въздействие.</li><li>Получете резултата си от самооценката на нивото на развитие.</li><li>Намерете добри практики, за да изведете Вашата компания на следващото ниво.</li><li>Учете се от реални практически примери от мебелния сектор, за да увеличавате непрекъснато положителното си въздействие.</li></ul>",
    msgHomeSection3: "Партньори",
    msgHomeSection2Btn: "Започнете оценката си",
    msgHomeSection3Btn: "КОНТАКТ",
    
    /** HEADER */
    msgHeader1: "Добри практики",
    msgHeader4: "Влизане в системата",
    
    /** DRAWER */
    msgCompany: "КОМПАНИЯ",
    msgDrawer1: "FurnCSR Оценка",
    msgDrawer2: "Доклад за изпълнение",
    msgDrawer3: "Доклад за подобрения",
    msgDrawer4: "Сборник с добри практики",
    msgDrawer5: "Относно нивата на FurnCSR",
    msgDrawer6: "Настройки",
    msgDrawer7: "Излизане от системата",
    msgDrawer8: "Оценете своя опит",
    
    /** LOGIN */
    msgWelcome: "Добре дошли",
    msgWelcomeSubtitle: "Моля, влезте в профила си, за да продължите",
    
    /** REGISTER */
    msgGetStarted: "Започнете",
    msgGetStartedSubtitle: "Този инструмент за управление на въздействието е безплатен и поверителен",
    
    msgFirstname: "Име",
    msgLastname: "Фамилия",
    msgEmail: "Имейл",
    msgPassword: "Парола",
    msgConfirmPassword: "Потвърдете паролата",
    msgCompanyUser: "Компания или потребителско име",
    
    msgNotRegister: "Още не сте регистрирани? <b>Създайте профил тук</b>",
    msgAlreadyRegister: "Вече сте регистрирани? <b>Влезте в системата тук</b>",
    
    /** HOME TOOL */
    msgClickImage: "Кликнете, за да разширите бизнес панела на FurnCSR.",
    
    msgArea: "ОБЛАСТ",
    msgProgress: "ВЪПРОСИ, КОИТО ВИЖДАТЕ",
    
    msgAssessmentAreas: "Области на въздействие на FurnCSR",
    msgAssessmentDesc: "Всички въпроси в инструмента FurnCSR са организирани съобразно основните бизнес блокове на една социално отговорна мебелна компания. Това е бизнес панела FurnCSR. Производството и вътрешните операции са в лявата част на платното, докато предлагането и външните практики са изобразени в дясната част. Използваме трислоен подход (икономически/организационен, обществен и екологичен), за да оценим ориентираните към КСО бизнес дейности във всеки блок. ",
    
    msgAssessment: "FurnCSR Оценка",
    msgNotApply: "Отбележете отговорите, които се отнасят до текущото развитие на Вашата компания. Ако нито един отговор не е приложим, не отбелязвайте нито един вариант.",
    msgMarkImportant: "Отбележете като важно",
    msgComment: "Коментар",
    msgCommentHolder: "Тук можете да запишете всякаква свързана информация или свои коментари.",
    
    /** PERFORMANCE REPORT */
    msgPerformance: "Доклад за изпълнение",
    msgPerformanceSubtitle: "Проверете резултата си от самооценката на нивото на развитие за всеки бизнес блок и общия резултат.",
    msgCompanyLevel: "Нивото на Вашата компания",
    msgBlockArea: "ОБЛАСТ НА БЛОКА",
    
    /** IMPROVEMENT REPORT */
    msgImprovement: "Доклад за подобрения",
    msgImprovementMainSubtitle: "Научете какво можете да направите, за да се усъвършенствате непрекъснато. Намерете още добри практики и бизнес казуси, за да изведете Вашата компания на следващото ниво.</br></br>Можете да започнете да четете и да се вдъхновявате от тези, които се съдържат в по-ниските нива, а след това да разгледате и да се опитате да приложите постепенно тези от по-високите нива. Не забравяйте, че практиките от нива 1 и 2 трябва да спазват изискванията на законодателството и наредбите, така че изпълнението им е законно задължение и затова е много важно да бъдат спазени.",
    msgImprovementSubtitle: "Научете какво можете да направите, за да се усъвършенствате непрекъснато. Намерете още добри практики и бизнес казуси, за да изведете Вашата компания на следващото ниво.",
    msgLevels: "Нива",
    msgActionsToImplement: "Действия за прилагане:",
    msgBaselineScore: "Моят базов резултат",
    msgBusinessCaseEmpty: "Поздравления! Вече сте приложили основните добри практики, включени в тази категория",
    
    msgCat1: "ИКОНОМИЧЕСКО И ОРГАНИЗАЦИОННО",
    msgCat2: "СОЦИАЛНО",
    msgCat3: "ОКОЛНА СРЕДА",
    
    /** GOOD PRACTICES COLLECTION */
    msgGoodPracticesSubtitle: "Разгледайте и проучете пълния сборник от добри практики и бизнес казуси на проекта FurnCSR",
    msgBusinessBlock: "Бизнес блок",
    msgLevel: "Ниво",
    msgDimension: "Размер",
    msgStep: "Step",
    
    /** SETTINGS */
    msgUserInfo: "Информация за потребителя",
    msgUserCredentials: "Пълномощия на потребителя",
    
    /** MODAL */
    msgAreSure: "Сигурни ли сте?",
    
    msgSuccess: "Успешно актуализиране на данните",
    msgDeleteSuccess: "Успешно актуализиране на данните",
    
    /** ERROR */
    errorOblData: "Успешно изтриване на данните",
    errorEmailFormat: "Грешка във формата на имейла",
    errorUserIncorrect: "Неправилен имейл/парола",
    errorSend: "Грешка в комуникацията, моля, изчакайте и опитайте отново по-късно",
    errorLength: "Броят на символите е превишен",
    errorPassSame: "Паролите не са еднакви",
    
    /** FOOTER */
    msgFooterContact: "КОНТАКТ",
    msgFooterLinkedIn: "LINKEDIN",
    msgFooterTwitter: "TWITTER",
    
    msgFooterGr: "Този проект е финансиран от инициативата на Европейската комисия: Подкрепа за социалния диалог VP/2020/001",
    msgCopyright: "Авторско право&копие;2023 AMBIT. Всички права запазени",
    
    msgFooterLegal: "Правно уведомление",
    msgFooterPrivacy: "Поверителност",
    msgFooterCookies: "Политика за използване на бисквитки",
    
    /** PROGRESS VALUES */
    msgProgress0: "Области на подобрение",
    msgProgress1: "Спазване на нормативните изисквания",
    msgProgress2: "Регулаторно подобряване",
    msgProgress3: "Изпълнение на очакванията",
    msgProgress4: "Ангажимент",
    
    /** COMPANY SIZES */
    msgCompanySize: "Размер на компанията",
    msgCompanySize1: "По-малко от 10 служители",
    msgCompanySize2: "10-30",
    msgCompanySize3: "30-50",
    msgCompanySize4: "Повече от 50 служители",
    
    /** PRODUCT TYPES */
    msgProductType: "Вид на продуктите, които произвеждате",
    msgProductType1: "Тапицерия",
    msgProductType2: "Матраци",
    msgProductType3: "Основи за тапицерии, канапета, основи за легла",
    msgProductType4: "Подизпълнител (рамки, механична обработка, лакиране и др.)",
    msgProductType5: "Услуги (специализирана логистика и др.)",
    msgProductType6: "Мебели от плоскости (меламин, фурнир, лак и др.)",
    msgProductType7: "Мебели от дърво",
    msgProductType8: "Столове",
    msgProductType9: "Офис мебели",
    msgProductType10: "Мебели за обществени пространства и приложения",
    msgProductType11: "Врати, прозорци и дърводелски изделия",
    msgProductType12: "Обекти по поръчка (магазини, библиотеки, ресторанти, професионални предприятия и др.)",
    msgProductType13: "Осветление",
    msgProductType14: "Покрития и подови настилки",
    msgProductType15: "Текстил",
    msgProductType16: "Декорации",

    /** ABOUT */
    msgAboutSec1Title: "Въведение в модела на насоките за напредък на FurnCSR",
    msgAboutSec1Text1:"Насоките за напредък, които представяме във FurnCSR, ни позволяват да определим практиките за КСО на организацията, докато липсата на подходящи практики в някои кутии ще ни позволи да открием пропуски, които да коригираме.</br></br>Създадени от методологичните основи на КСО, Насоките за напредък показват, глобално и по структуриран начин, позицията, в която е консолидирана една организация, и пътя, който трябва да поеме в управлението на КСО.</br></br>Моделът се основава на пет нива, които, дублирани в две колони, предлагат 10 степени, от областите за подобрение до максималното ниво на ангажираност. Ние показваме основния модел по опростен начин с цел предоставяне на други предложения за добри практики, различни от предишните (т.е. глава 4) в смисъл, че те ще позволят напредък в интегрираното разработване на модел на КСО.</br></br>Следните фигури показват различните нива и степени на зрялост по отношение на КСО.</br></br>Отивайки нагоре в първата колона (кутия 0), наблюдаваме различните степени между законово (не)съответствие и максималното ниво на ангажираност (кутия 9). Нагоре в колоната вдясно, която показва по-голяма проактивност и основите на уникалната методология на КСО, постепенно се интегрира присъствието на заинтересованите страни и се показва напредъкът в логиката на корпоративната принадлежност. КСО иска да поправя, гарантира, разбира, да бъде отговорна и да създава споделена стойност извън това, което съответства на пвътрешно логично управление; не е достатъчно да правите нещата с възможно най-доброто намерение, трябва да генерирате въздействие, с автентичност и с доверието на заинтересованите страни.",
    msgAboutSec1Text2: "Това е път за напредък към съвършенство и дори заемането на средни позиции може да бъде от голяма полза за мебелната компания. Ще бъде важно да не оставяме теми в пониските области и да имаме визия как да продължим напред чрез интегриране не само на добрите практики, показани в предишната глава, но и на показаните по-долу, разположени в по-високите нива на този модел. Впоследствие насоките за напредък могат да бъдат приложени към всяко от трите измерения на управлението на КСО според техните собствени специфични характеристики, поддържайки същия път през цялото време, което прави възможно разбирането на еволюцията на степента на зрялост на КСО в мебелната компания.",

    msgAboutLevel1Title: "Области на подобрение (стъпки 0 и 1)",
    msgAboutLevel1Text: "Това ниво съответства на областите на подобрение и предполага, че има сериозни или разнообразни несъответствия, както правни, така и свързани с ангажименти, или все още е във фаза на корекция и поправка.",

    msgAboutLevel2Title: "Съответствие с нормативните изисквания (стъпки 2 и 3)",
    msgAboutLevel2Text: "Това ниво съответства на нормативно съответствие и означава, че изпълнява и гарантира спазването на задълженията, независимо дали са законови или произтичат от доброволни ангажименти. За организация, ангажирана с КСО, спазването на закона не е свързано само с буквалния текст, но и с намерението, което регулаторът цели от името на обществото, като се избягва нарушаването на закона. На ниво регулаторно съответствие са посочени практики, свързани със спазването на основните законови изисквания за индустрията, тъй като без това управлението на КСО не би могло да започне да се разглежда.",

    msgAboutLevel3Title: "Регулаторно подобрение (стъпки 4 и 5)",
    msgAboutLevel3Text: "Това ниво съответства на регулаторното подобрение и означава, че надхвърля законовите задължения с прилагането на най добрите практики. За организация, ангажирана с КСО, се провеждат разговори със заинтересованите страни, за да се разбере самият контекст на устойчивостта.",

    msgAboutLevel4Title: "Изпълнение на очакванията (Стъпка 6 и 7)",
    msgAboutLevel4Text: "Това ниво съответства на задоволяването на очакванията и означава, че очакванията на заинтересованите страни се адресират чрез систематизирано управление на КСО (планиране, действия, интегриране в процеси и процедури, оценка, непрекъснато подобряване...). За организация, ангажирана с КСО, се извършва прозрачна отчетност в посока към заинтересованите страни.",

    msgAboutLevel5Title: "Ангажимент (Стъпка 8 и 9)",
    msgAboutLevel5Text: "Това ниво съответства на ангажимент и означава, че се извършва ангажирано управление, с осъзнатост и лидерство, ясно и постоянно, всеобхватно, свързано със стратегическо планиране и с по-висока цел, с ориентация към създаване на споделена стойност със заинтересованите страни.",

    /* COUNTRIES */
    msgCountry: "Държава",
    msgAfghanistan: "Афганистан",
    msgAlbania: "Албания",
    msgAlgeria: "Алжир",
    msgAmericanSamoa: "Американска Самоа",
    msgAndorra: "Андора",
    msgAngola: "Ангола",
    msgAnguilla: "Ангуила",
    msgAntarctica: "Антарктика",
    msgAntiguaandBarbuda: "Антигуа и Барбуда",
    msgArgentina: "Аржентина",
    msgArmenia: "Армения",
    msgAruba: "Аруба",
    msgAustralia: "Австралия",
    msgAustria: "Австрия",
    msgAzerbaijan: "Азербайджан",
    msgBahamas: "Бахамите",
    msgBahrain: "Бахрейн",
    msgBangladesh: "Бангладеш",
    msgBarbados: "Барбадос",
    msgBelarus: "Беларус",
    msgBelgium: "Белгия",
    msgBelize: "Белиз",
    msgBenin: "Бенин",
    msgBermuda: "Бермудите",
    msgBhutan: "Бутан",
    msgBolivia: "Боливия",
    msgBosniaHerzegovina: "Босна и Херцеговина",
    msgBotswana: "Ботсвана",
    msgBouvetIsland: "Остров Буве",
    msgBrazil: "Бразилия",
    msgBritishIndian: "Британска територия в Индийския океан",
    msgBrunei: "Бруней",
    msgBulgaria: "България",
    msgBurkinaFaso: "Буркина Фасо",
    msgBurundi: "Бурунди",
    msgCambodia: "Камбоджа",
    msgCameroon: "Камерун",
    msgCanada: "Канада",
    msgCapeVerde: "Кабо Верде",
    msgCaymanIslands: "Кайманови острови",
    msgCentralAfrican: "Централноафриканска република",
    msgChad: "Чад",
    msgChile: "Чили",
    msgChina: "Китай",
    msgChristmasIsland: "остров Коледа",
    msgCocosIslands: "Кокосови (Кийлинг) острови",
    msgColombia: "Колумбия",
    msgComoros: "Коморски острови",
    msgCongo: "Конго",
    msgRepublicCongo: "Демократична република Конго",
    msgCookIslands: "Острови Кук",
    msgCostaRica: "Коста Рика",
    msgIvoryCoast: "Бряг на слоновата кост",
    msgCroatia: "Хърватия",
    msgCuba: "Куба",
    msgCyprus: "Кипър",
    msgCzechRepublic: "Чехия",
    msgDenmark: "Дания",
    msgDjibouti: "Джибути",
    msgDominica: "Доминика",
    msgDominicanRepublic: "Доминиканска република",
    msgEastTimor: "Източен Тимор",
    msgEcuador: "Еквадор",
    msgEgypt: "Египет",
    msgEngland: "Англия",
    msgElSalvador: "Ел Салвадор",
    msgEquatorialGuinea: "Екваториална Гвинея",
    msgEritrea: "Еритрея",
    msgEstonia: "Естония",
    msgEthiopia: "Етиопия",
    msgFalklandIslands: "Фолкландски острови",
    msgFaroeIslands: "Фарьорските острови",
    msgFijiIslands: "Острови Фиджи",
    msgFinland: "Финландия",
    msgFrance: "Франция",
    msgFrenchGuiana: "Френска Гвиана",
    msgFrenchPolynesia: "Френска полинезия",
    msgFrenchSouthern: "Френски южни територии",
    msgGabon: "Габон",
    msgGambia: "Гамбия",
    msgGeorgia: "Грузия",
    msgGermany: "Германия",
    msgGhana: "Гана",
    msgGibraltar: "Гибралтар",
    msgGreece: "Гърция",
    msgGreenland: "Гренландия",
    msgGrenada: "Гренада",
    msgGuadeloupe: "Гваделупа",
    msgGuam: "Гуам",
    msgGuatemala: "Гватемала",
    msgGuernsey: "Гърнси",
    msgGuinea: "Гвинея",
    msgGuineaBissau: "Гвинея-Бисау",
    msgGuyana: "Гвиана",
    msgHaiti: "Хаити",
    msgHeardMcDonald: "Остров Хърд и островите Макдоналд",
    msgHolySee: "Светият престол (град-държава Ватикана)",
    msgHonduras: "Хондурас",
    msgHongKong: "Хонг Конг",
    msgHungary: "Унгария",
    msgIceland: "Исландия",
    msgIndia: "Индия",
    msgIndonesia: "Индонезия",
    msgIran: "Иран",
    msgIraq: "Ирак",
    msgIreland: "Ирландия",
    msgIsrael: "Израел",
    msgIsleMan: "остров Ман",
    msgItaly: "Италия",
    msgJamaica: "Ямайка",
    msgJapan: "Япония",
    msgJersey: "Джърси",
    msgJordan: "Джордан",
    msgKazakhstan: "Казахстан",
    msgKenya: "Кения",
    msgKiribati: "Кирибати",
    msgKuwait: "Кувейт",
    msgKyrgyzstan: "Киргизстан",
    msgLaos: "Лаос",
    msgLatvia: "Латвия",
    msgLebanon: "Ливан",
    msgLesotho: "Лесото",
    msgLiberia: "Либерия",
    msgLibyanJamahiriya: "Либийска арабска джамахирия",
    msgLiechtenstein: "Лихтенщайн",
    msgLithuania: "Литва",
    msgLuxembourg: "Люксембург",
    msgMacao: "Макао",
    msgNorthMacedonia: "Северна Македония",
    msgMadagascar: "Мадагаскар",
    msgMalawi: "Малави",
    msgMalaysia: "Малайзия",
    msgMaldives: "Малдивите",
    msgMali: "Мали",
    msgMalta: "Малта",
    msgMarshallIslands: "Маршалови острови",
    msgMartinique: "Мартиника",
    msgMauritania: "Мавритания",
    msgMauritius: "Мавриций",
    msgMayotte: "Майот",
    msgMexico: "Мексико",
    msgMicronesia: "Микронезия, Федерални щати",
    msgMoldova: "Молдова",
    msgMonaco: "Монако",
    msgMongolia: "Монголия",
    msgMontserrat: "Монсерат",
    msgMontenegro: "Черна гора",
    msgMorocco: "Мароко",
    msgMozambique: "Мозамбик",
    msgMyanmar: "Мианмар",
    msgNamibia: "Намибия",
    msgNauru: "Науру",
    msgNepal: "Непал",
    msgNetherlands: "Холандия",
    msgNetherlandsAntilles: "Холандски Антили",
    msgNewCaledonia: "Нова Каледония",
    msgNewZealand: "Нова Зеландия",
    msgNicaragua: "Никарагуа",
    msgNiger: "Нигер",
    msgNigeria: "Нигерия",
    msgNiue: "Ниуе",
    msgNorfolkIsland: "Остров Норфолк",
    msgNorthKorea: "Северна Корея",
    msgNorthernIreland: "Северна Ирландия",
    msgNorthernMariana: "Северни Мариански острови",
    msgNorway: "Норвегия",
    msgOman: "Оман",
    msgPakistan: "Пакистан",
    msgPalau: "Палау",
    msgPalestine: "Палестина",
    msgPanama: "Панама",
    msgPapua: "Папуа-Нова Гвинея",
    msgParaguay: "Парагвай",
    msgPeru: "Перу",
    msgPhilippines: "Филипините",
    msgPitcairn: "Питкерн",
    msgPoland: "Полша",
    msgPortugal: "Португалия",
    msgPuertoRico: "Пуерто Рико",
    msgQatar: "Катар",
    msgReunion: "Обединение",
    msgRomania: "Румъния",
    msgRussianFederation: "Руска федерация",
    msgRwanda: "Руанда",
    msgSaintHelena: "Света Елена",
    msgSaintKitts: "Сейнт Китс и Невис",
    msgSaintLucia: "Сейнт Лусия",
    msgSaintPierre: "Сен Пиер и Микелон",
    msgSaintVincent: "Сейнт Винсент и Гренадини",
    msgSamoa: "Самоа",
    msgSanMarino: "Сан Марино",
    msgSaoTome: "Сао Томе и Принсипи",
    msgSaudiArabia: "Саудитска Арабия",
    msgScotland: "Шотландия",
    msgSenegal: "Сенегал",
    msgSerbia: "Сърбия",
    msgSeychelles: "Сейшели",
    msgSierraLeone: "Сиера Леоне",
    msgSingapore: "Сингапур",
    msgSlovakia: "Словакия",
    msgSlovenia: "Словения",
    msgSolomonIslands: "Соломоновите острови",
    msgSomalia: "Сомалия",
    msgSouthAfrica: "Южна Африка",
    msgSouthSandwich: "Южна Джорджия и Южните Сандвичеви острови",
    msgSouthKorea: "Южна Кореа",
    msgSouthSudan: "Южен Судан",
    msgSpain: "Испания",
    msgSriLanka: "Шри Ланка",
    msgSudan: "Судан",
    msgSuriname: "Суринам",
    msgSvalbardJan: "Свалбард и Ян Майен",
    msgSwaziland: "Свазиленд",
    msgSweden: "Швеция",
    msgSwitzerland: "Швейцария",
    msgSyria: "Сирия",
    msgTajikistan: "Таджикистан",
    msgTanzania: "Танзания",
    msgThailand: "Тайланд",
    msgTimorLeste: "Източен Тимор",
    msgTogo: "Да отида",
    msgTokelau: "Токелау",
    msgTonga: "Тонга",
    msgTrinidadTobago: "Тринидад и Тобаго",
    msgTunisia: "Тунис",
    msgTurkey: "Турция",
    msgTurkmenistan: "Туркменистан",
    msgTurksCaicos: "острови Търкс и Кайкос",
    msgTuvalu: "Тувалу",
    msgUganda: "Уганда",
    msgUkraine: "Украйна",
    msgUnitedArabEmirates: "Обединени арабски емирства",
    msgUnitedKingdom: "Великобритания",
    msgUnitedStates: "Съединени щати",
    msgUnitedStatesMinor: "Малки отдалечени острови на Съединените щати",
    msgUruguay: "Уругвай",
    msgUzbekistan: "Узбекистан",
    msgVanuatu: "Вануату",
    msgVenezuela: "Венецуела",
    msgVietnam: "Виетнам",
    msgVirginIslandsBritish: "Британски Вирджински острови",
    msgVirginIslandsUS: "Вирджински острови, САЩ",
    msgWales: "Уелс",
    msgWallisFutuna: "Уолис и Футуна",
    msgWesternSahara: "западна Сахара",
    msgYemen: "Йемен",
    msgZambia: "Замбия",
    msgZimbabwe: "Зимбабве",
}

export default bg;